<template>
    <tag-editor
        :unique-id="rowData.id"
        :tags-url="`${TENANT_BASE_URL}app/finance-transaction-imports/${rowData.id}/tags`"
        :update-url="`${TENANT_BASE_URL}app/finance-transaction-imports/${rowData.id}/tags`"
        :all-tags-url="`${TENANT_BASE_URL}app/interview-tag?per_page=0&type=3`"
        label-field="title"
        :title="$t('manage_tags')"
        icon="tag"
        button-class="primary-text-color"
        :editable="rowData.status !== 'error' && rowData.status !== 'converted'"
        @updated="onTagsUpdated"
    />
</template>

<script>
import TagEditor from "../../Helper/TagEditor.vue";
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";

export default {
    name: "FinanceTagCell",
    components: {
        TagEditor
    },
    props: {
        value: {},
        rowData: {},
        tableId: {}
    },
    data() {
        return {
            TENANT_BASE_URL
        }
    },
    methods: {
        onTagsUpdated() {
            // Reload the table when tags are updated
            // this.$hub.$emit('reload-finance-transaction-import-table');
        }
    }
}
</script>
